module.exports = __webpack_public_path__ + "img/192.8cd812c0.jpg";